module.exports = require("buffer");


//////////////////
// WEBPACK FOOTER
// external "buffer"
// module id = 20
// module chunks = 0